export const indiConstants = {
    SAVE_INDI_PERMANENT_SUBSCRIPTION: "save_indi_permanent_subscription",
    SET_INDI_PARAMETER_VALUE: "SET_INDI_PARAMETER_VALUE"
};